import { baseUrl } from "./baseUrl";
import buildUrl from "../utils/buildUrl";

// ex getServicesRoute
export const getMassServicesRoute = (params) =>
  buildUrl({
    url: `${baseUrl}/services-api/services/search`,
    searchParams: params,
  });

export const getServicesRoute = () => [`${baseUrl}`, "services-api", "services"].join("/");

export const getGenericServicesRoute = (...dirNames) =>
  [`${baseUrl}`, "services-api", ...dirNames].join("/");

export const getServiceTypeVersionsRoute = (serviceTypeId) =>
  [`${baseUrl}`, "offerings-api", "service-types", serviceTypeId, "versions"].join("/");

export const getServiceAgreementVersionsRoute = (agreementId) =>
  [`${baseUrl}`, "accounts-api", "agreements", agreementId, "versions"].join("/");

export const getTariffsVersionsRoute = (tariffId) =>
  [`${baseUrl}`, "offerings-api", "tariffs", tariffId, "versions"].join("/");

export const getServiceTypesRoute = (onDate) =>
  buildUrl({
    url: [`${baseUrl}`, `offerings-api`, "service-types"].join("/"),
    searchParams: {
      onDate,
    },
  });

export const getServiceTypesVersionsRoute = (id) =>
  [`${baseUrl}`, "offerings-api", "service-types", `${id}`, "versions"].join("/");

export const createServiceTypesRoute = () =>
  [`${baseUrl}`, "offerings-api", "service-types"].join("/");

export const createServiceTypeOrDeleteVersionRoute = (id, fromDate) =>
  [
    `${baseUrl}`,
    `/offerings-api`,
    "/service-types",
    `/${id}`,
    `?fromDate=${encodeURIComponent(fromDate)}`,
  ].join("");

export const getTaxesSummary = (id, onDate) =>
  buildUrl({
    url: [`${baseUrl}`, `offerings-api`, "taxes", "summary"].join("/"),
    searchParams: {
      serviceTypeId: id,
      amount: 1,
      amountType: "NET",
      onDate,
    },
  });

export const getTaxesRates = (onDate) =>
  buildUrl({
    url: [`${baseUrl}`, "offerings-api", "tax-rates"].join("/"),
    searchParams: {
      onDate,
    },
  });

export const updateServiceStatusRoute = (date) =>
  [
    `${baseUrl}`,
    "/services-api",
    "/services/statuses",
    `?fromDate=${encodeURIComponent(date)}`,
  ].join("");

export const changeServiceProfileRoute = ({ serviceId, fromDate, toDate, force }) => {
  const searchParams = [
    `fromDate=${encodeURIComponent(fromDate)}`,
    `toDate=${encodeURIComponent(toDate)}`,
    `force=${force}`,
  ].join("&");
  return [
    `${baseUrl}`,
    "services-api/services",
    `${serviceId}`,
    `service-profiles?${searchParams}`,
  ].join("/");
};

export const getServicesBlockingTypeStatusRoute = ({ objectTypeId, objectId, onDate }) => {
  return buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking/${objectTypeId}/${objectId}/status`,
    searchParams: { onDate },
  });
};
